import apiClient from './client';

type TvLoginResponse = {
  success: boolean;
  data: {
    authenticated: boolean;
    access_token?: string;
    user_id?: number;
  } | null;
  error: string | null;
};

/**
 * Authenticate the TV directly with email + password as an alternative to the
 * pair-code flow. Used by app-store reviewers who don't have a paired phone.
 */
export async function loginTvWithEmailAndPassword(
  email: string,
  password: string,
  tvUuid: string,
): Promise<TvLoginResponse> {
  const response = await apiClient.post('/tv/login', {
    email,
    password,
    tv_uuid: tvUuid,
  });
  return response.data;
}
